window.app.controller('searchCtrl', ['$scope', function ($scope) {

  $scope.leftSpan = "<span class=\"searchSelectedZone\">";
  $scope.rightSpan = "</span>";

    $scope.sendSearchData = function () {
      console.log($scope.searchRequest.request);
      $scope.sendXHR({
            url: '/api/front/search/search/search',
            data: $scope.searchRequest.request,
            successFunc: $scope.getResult }, false);
    };

    $scope.getResult = function (res) {
      if(res.data.source) {
        $scope.selectedZone = res.data.substr;
        $scope.reslutSearch = res.data.source;
      } else {
        $scope.reslutSearch = false;
      }
    };

  $scope.getContent = function(zone){
    var pattern = new RegExp($scope.selectedZone, 'gi');
    return zone.replace(pattern,  $scope.leftSpan + $scope.selectedZone + $scope.rightSpan);
  };

  $(document).click(function(event) {
    if(!$(event.target).closest('#menucontainer').length && $('#menucontainer').is(":visible")) {
      $scope.searchRequest.request = '';
    }
  });

}]);



// WEBPACK FOOTER //
// src/js/controllers/main/searchCtrl.js